/**
 * User dropdown Button size options.
 * Each option references the class it will be given.
 * Class detials can be found in UserDropdown component.
 */

const UserDropdownButtonSize = {
    XS: 'xs-button',
    S: 's-button',
    M: 'm-button',
    L: 'l-button',
    XL: 'xl-button',
    XXL: 'xxl-button',
}

export default UserDropdownButtonSize;